import React from "react";
import { useTimeSheetStore } from "../../../../config/stores";
import PrintOutHeader from "../../../../components/shared/PrintOutHeader";
import { Divider } from "antd";

const PrintDayTimeSheet = ({ dayActivities = [] }) => {
  const timeSheetStore = useTimeSheetStore();

  const { timeSheetDetails } = timeSheetStore;
  return (
    <div className="m-1 p-1 border">
      <PrintOutHeader />
      <table className="table table-bordered table-striped table-sm">
        <tbody>
          <tr>
            <td>DATE</td>
            <td>{timeSheetStore.timeSheetActivitiesDate.date}</td>
          </tr>
          <tr>
            <td>NAME OF STAFF</td>
            <td>
              {timeSheetDetails?.user?.first_name || ""}{" "}
              {timeSheetDetails?.user?.other_names || ""}
            </td>
          </tr>
          <tr>
            <td>POSITION</td>
            <td>{timeSheetDetails?.role?.role || ""}</td>
          </tr>
        </tbody>
      </table>
      <Divider className="fw-bold">ACTIVITIES</Divider>
      <table className="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th>PROJECT</th>
            <th>ACTIVITY</th>
            <th>HOURS</th>
          </tr>
        </thead>
        <tbody>
          {dayActivities.map((activity) => (
            <tr key={activity.id}>
              <td>{activity.project?.name || "SHARED"}</td>
              <td>{activity.activity}</td>
              <td className="text-center">{activity.hours}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={2} className="text-end fw-bold">
              TOTAL HOURS
            </td>
            <td className="fw-bold text-center">
              {dayActivities.reduce((sum, activity) => sum + activity.hours, 0)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PrintDayTimeSheet;
